import React, { useState } from 'react'
import Navega from '../componentes/Nav'
import '../estilos/Contacto.css'
import Footer from '../componentes/footer'
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: '',
    mensaje: ''
  })
  const { t } = useTranslation();
  const [enviando, setEnviando] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

 const handleSubmit = (e) => {
  e.preventDefault()
  setEnviando(true)

  emailjs.send(
    'service_0j02wtl',
    'template_ob30m9q',
    {
      nombre: formData.nombre,
      apellido: formData.apellido,
      email: formData.email,
      telefono: formData.telefono,
      mensaje: formData.mensaje,
    },
    'NIzwNDs-f6gf4kzSL'
  )
  .then(() => {
    alert('✅ Mensaje enviado correctamente')
    setEnviando(false)
    setFormData({ nombre: '', apellido: '', email: '', telefono: '', mensaje: '' })
  })
  .catch((error) => {
    console.error('Error:', error)
    alert('❌ Hubo un error al enviar el mensaje. Intenta de nuevo.')
    setEnviando(false)
  })
}

  return (
    <>
      <Navega />
      
      <main className="contacto-page">
        {/* Hero Section */}
        <section className="contacto-hero">
          <div className="hero-content">
            <h1>{t('contacto_titulo')}</h1>
            <p>{t('contacto_subtitulo')}</p>
          </div>
        </section>

        {/* Main Content */}
        <section className="contacto-content">
          <div className="contacto-grid">
            
            {/* Formulario */}
            <div className="contacto-form-container">
              <h2>{t('contacto_form_titulo')}</h2>
              <form onSubmit={handleSubmit} className="contacto-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nombre">{t('contacto_nombre')}</label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      required
                      placeholder="Tu nombre"
                    />
                  </div>
                  <div className="form-group">
                   <label htmlFor="apellido">{t('contacto_apellido')}</label>
                    <input
                      type="text"
                      id="apellido"
                      name="apellido"
                      value={formData.apellido}
                      onChange={handleChange}
                      required
                      placeholder="Tu apellido"
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">{t('contacto_email')}</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="telefono">{t('contacto_telefono')}</label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleChange}
                      placeholder="+506 0000 0000"
                    />
                  </div>
                </div>

                <div className="form-group full-width">
                 <label htmlFor="mensaje">{t('contacto_mensaje')}</label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder={t('contacto_placeholder_mensaje')}
                  />
                </div>

                <button type="submit" className="btn-enviar" disabled={enviando}>
                  {enviando ? t('contacto_enviando') : t('contacto_btn')}
                </button>
              </form>
            </div>

            {/* Info de contacto */}
            <div className="contacto-info">
             <h2>{t('contacto_info_titulo')}</h2>
              
              {/* Oficina Costa Rica */}
              <div className="location-card">
                <div className="location-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 3.827 3.024Z" clipRule="evenodd"/>
                  </svg>
                </div>
                <div className="location-details">
                  <h3>Head Office - Costa Rica</h3>
                  <p>Liberia, Guanacaste</p>
                  <p>Costa Rica</p>
                  <a href="tel:+50686952" className="phone-link">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd"/>
                    </svg>
                    +506 64643174
                  </a>
                </div>
              </div>

              {/* Oficina USA */}
              <div className="location-card">
                <div className="location-icon usa">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 3.827 3.024Z" clipRule="evenodd"/>
                  </svg>
                </div>
                <div className="location-details">
                  <h3>United States Office</h3>
                  <p>Vero Beach, Florida</p>
                  <p>United States - 32960</p>
                  <a href="tel:+11987" className="phone-link">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd"/>
                    </svg>
                    +1 (772) 888-1987
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="location-card email-card">
                <div className="location-icon email">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"/>
                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"/>
                  </svg>
                </div>
                <div className="location-details">
                  <h3>Email</h3>
                  <a href="mailto:info@pacifictourcr.com" className="email-link">
                    info@pacifictourcr.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mapa */}
        <section className="contacto-mapa">
          <h2>{t('contacto_mapa')}</h2>
          <div className="mapa-container">
            <iframe
              title="Ubicación Pacific Tour CR"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-85.44362545013429%2C10.62890625%2C-85.42362545013428%2C10.64890625&layer=mapnik&marker=10.633333%2C-85.436286"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
          <p className="coordenadas">Coordenadas: 10°38'00.0"N 85°26'10.6"W</p>
        </section>
      </main>

      <Footer />

    </>
  )
}

export default Contacto
